import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { CountBadge } from './CountBadge';
import { generateTestId } from 'app/functions';

export const CouponTab = ({ label, count, isActive, onClick, testID }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  
  return (
    <Box
      testId={testID}
      dir="rtl"
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: `${spacing.sm}px`,
        paddingLeft: `${spacing.sm}px`,
        paddingRight: `${spacing.sm}px`,
        paddingBottom: `calc(${spacing.sm}px + 3px + ${spacing.sm}px)`,
        width: isMobile ? '50%' : 'auto',
        minWidth: isMobile ? '50%' : 'auto',
        maxWidth: isMobile ? '50%' : 'none',
        boxSizing: 'border-box',
        minHeight: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        position: 'relative',
      }}
    >
      <Box 
        testId={generateTestId(testID, 'content')} 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: `${spacing.sm}px`, 
          width: '100%', 
          justifyContent: 'center', 
          flexShrink: 0,
          height: `${spacing.xxl}px`,
          minHeight: `${spacing.xxl}px`,
        }}
      >
        <TextHot
          testID={generateTestId(testID, 'label')}
          size={isMobile ? 'l' : 'xxl'}
          isLtr={true}
          bold={isActive ? 'bold' : 'regular'}
          color={isActive ? colors.system.text.subtle : colors.system.text.primary}
          sx={{
            whiteSpace: 'nowrap',
            fontWeight: isActive ? 'bold' : 'normal',
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: 1,
            height: 'fit-content',
          }}
        >
          {label}
        </TextHot>
        <CountBadge testID={generateTestId(testID, 'count')} count={count} isActive={isActive} />
      </Box>
      <Box
        testId={generateTestId(testID, 'underline')}
        sx={{
          position: 'absolute',
          bottom: `${spacing.sm}px`,
          left: `${spacing.sm}px`,
          right: `${spacing.sm}px`,
          height: 2,
          borderRadius: `${radius.xs}px`,
          backgroundColor: isActive ? colors.palette.blue800 : 'transparent',
          flexShrink: 0,
        }}
      />
    </Box>
  );
};

export default CouponTab;

